<template>
  <div class="header">
    <!-- <img class="header-img pc-container" src="../../assets/images/pc/common/header.jpg" > -->
    <div class="header-menu pc-container">
    <img class="header-menu__bg" src="../../assets/images/pc/common/menu_bar_bg.jpg" >
      <div class="header-menu__container">
        <div :class="['button', route.isActive && 'active-menu']" v-for="(route, index) in routes" :key="index" @click="handleTitleClick(index)">
          <img :src="`${require(`../../assets/images/pc/common/title_0${index + 1}.png`)}`"/>
        </div>
      </div>
    </div>
    <div class="header-menu mobile-container">
      <!-- <img class="header-img" src="../../assets/images/mobile/common/header.jpg" > -->
      <img class="header-menu__bg" src="../../assets/images/mobile/common/menu.jpg" >
      <div class="menu-block" @click="handleMenuClick"></div>
      <div class="mobile-menu__container" :class="showMobileMenu && 'show'">
        <div :class="['button', route.isActive && 'active-menu']" v-for="(route, index) in routes" :key="index" @click="handleTitleClick(index)">
          <img v-if="!route.isActive" :src="`${require(`../../assets/images/mobile/common/0${index + 1}_normal.jpg`)}`"/>
          <img v-else :src="`${require(`../../assets/images/mobile/common/0${index + 1}_active.jpg`)}`"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '../../utils'
export default {
  data() {
    return {
      routes: [
        {
          name: 'Home',
          isActive: false,
          path: '/pingancx'
        },{
          name: 'Competition',
          isActive: false,
          path: '/pingancx/competition/production'
        },{
          name: 'Limited',
          isActive: false,
          path: '/pingancx/limited/peak'
        },{
          name: 'Promotion',
          isActive: false,
          path: '/pingancx/promotion/production'
        },{
          name: 'Question',
          isActive: false,
          path: '/pingancx/question'
        },{
          name: 'News',
          isActive: false,
          path: '/pingancx/news'
        }
      ],
      showMobileMenu: false
    }
  },
  watch: {
    $route () {
      this.routes.forEach(item => {
        if (this.$route.name === item.name) {
          item.isActive = true
        } else {
          item.isActive = false
        }
      })
    }
  },
  methods: {
    handleTitleClick (index) {
      const currentRoute = this.routes[index]
      this.$router.replace(currentRoute.path)
      // this.showMobileMenu = false
    },
    handleMenuClick () {
      this.showMobileMenu = !this.showMobileMenu
    }
  },
  computed: {
    isPc() {
      return Utils.isPc()
    }
  }
}
</script>
<style scoped>
.header{
  position: fixed;
  z-index: 10;
  top: 0px;
  left: 0px;
}
.header, .header-img, .header-menu__bg{
  width: 100%;
  /* min-width: 1200px; */
  /* z-index: 10; */
}

.header-menu__container{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.header-menu{
  z-index: 10;
}

.header-menu .button{
  position: relative;
  height: 100%;
  width: 8.1vw;  
}
.header-menu .button img{
  position: absolute;
  height: 100%;
  width: auto;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.active-menu{
  background-image: url(../../assets/images/pc/common/active_bg.jpg);
  background-size: 100% 100%;
}
.menu-block{
  position: absolute;
  width: 15%;
  height: 40%;
  right: 0px;
  top: 60%;
  z-index: 10;
}

.mobile-menu__container{
  position: absolute;
  width: 15%;
  height: 40%;
  right: 0px;
  top: 180%;
  z-index: 10;
  display: none;
}
.mobile-menu__container .active-menu{
  background: none;
}
.mobile-menu__container.show{
  display: block;
}
.mobile-menu__container .button{
  height: auto;
  width: 100%;
}
.mobile-menu__container .button img{
  position: relative;
  width: 100%;
  height: auto;
}
</style>